module.exports = __webpack_public_path__ + "img/swiper_nav4.9a25a702.png";